import { createFileRoute } from '@tanstack/react-router';
import { RewardsPage } from '../../pages/RewardsPage';
import { ProtectedRoute } from '../../../../shared/ui';

// Define search params type
type RewardsSearch = {
  payment_id?: string;
};

export const Route = createFileRoute('/rewards/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): RewardsSearch => {
    return {
      payment_id: search.payment_id as string,
    };
  },
});

function RouteComponent() {
  const { payment_id } = Route.useSearch();
  return (
    <ProtectedRoute>
      <RewardsPage paymentId={payment_id} />
    </ProtectedRoute>
  );
}
